var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#2160aa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5833 13.4368L19.0417 9.93685L20.2083 8.77018C20.5278 8.45074 20.9203 8.29102 21.3858 8.29102C21.8508 8.29102 22.2431 8.45074 22.5625 8.77018L23.7292 9.93685C24.0486 10.2563 24.2153 10.6418 24.2292 11.0935C24.2431 11.5446 24.0903 11.9299 23.7708 12.2493L22.5833 13.4368ZM21.375 14.666L12.5417 23.4993H9V19.9577L17.8333 11.1243L21.375 14.666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImageIcon);
export default __webpack_public_path__ + "static/media/edit_image_icon.8424c28f683a5be28232a3073cae5f3f.svg";
export { ForwardRef as ReactComponent };